import { initializeApp } from 'firebase/app';
import {
  getAuth,
  isSignInWithEmailLink,
  sendSignInLinkToEmail,
  signInWithEmailLink,
  updateProfile,
  onAuthStateChanged,
  signOut,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAE6b2ufHE0QWZd5xlGRZXBycocGoT03t0",
  authDomain: "transport-manager-doc-portal.firebaseapp.com",
  projectId: "transport-manager-doc-portal",
  storageBucket: "transport-manager-doc-portal.firebasestorage.app",
  messagingSenderId: "538437082162",
  appId: "1:538437082162:web:ec7a6f4368adce20ba302b"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// 2) Email link (passwordless) settings – returns to /finish-sign-in
export const emailLinkSettings = {
  url: `${window.location.origin}/finish-sign-in`,
  handleCodeInApp: true,
};

export {
  isSignInWithEmailLink,
  sendSignInLinkToEmail,
  signInWithEmailLink,
  updateProfile,
  onAuthStateChanged,
  signOut,
};